import React, { useEffect, useState } from "react";
import "./Header.css";
import { Row, Col, Modal } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Arrow from "../../../../assets/Images/product/arrow.svg";
import Qr from "../../../../assets/Images/product/image 1.png";
import PlayVideo from "../../../../assets/Images/svg/play-video.svg";
import { Gallery, ComingSoon } from "../../../../Components";

const Header = ({ productData, url }) => {
  const [loading, setLoading] = useState(true);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (productData) {
      setLoading(false);
    }
  }, [productData]);

  const {
    name,
    web_item_name,
    item_code,
    item_group,
    short_description,
    website_image,
    brand,
    brand_image,
    demo_video,
    datasheet_qr_code,
    datasheet_url,
    gallery = [],
  } = productData || {};


  // Map gallery images if they exist, otherwise fallback to website_image
  const images = gallery.length > 0
  ? gallery.map((item) => {
      if (item.gallery_type === "Image" && item.image) {
        return {
          type: "image",
          src: `${url}/${item.image}`,
          alt: item.alt_text || "Gallery Image",
        };
      } else if (item.gallery_type === "YouTube" && item.video_link) {
        const getEmbedUrl = (videoUrl) => {
          const match = videoUrl.match(/(?:youtu\.be\/|v=)([^&]+)/);
          return match ? `https://www.youtube.com/embed/${match[1]}` : videoUrl;
        };
        return {
          type: "video",
          src: getEmbedUrl(item.video_link),
          alt: "YouTube Video",
        };
      }
      return null;
    }).filter(Boolean)
  : [];

  // If images gallery is not empty, then add the website_image to the images array as first item
  if (website_image && gallery.length > 0) {
    images.unshift({
      type: "image",
      src: `${url}/${website_image}`,
      alt: "Product Image",
    });
  };
  
  // Helper function to convert a YouTube URL to an embeddable format
  const getEmbedUrl = (url) => {
    if (url.includes("watch?v=")) {
      const videoId = url.split("watch?v=")[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return url; // Return the URL if it's already in the embed format
  };

  // Convert the demo video URL to embed format if it exists
  const embedVideoUrl = demo_video ? getEmbedUrl(demo_video) : null;

  const handleShowVideo = () => {
    setShowVideoModal(true);
  };

  const handleCloseVideo = () => {
    setShowVideoModal(false);
  };

  return (
    <div className="header-product-details">
      <Row className="header-product-details-row">
        <Col xs={12} sm={12} md={12} lg={6} className="content-column">
          <a className="qr-container" href={datasheet_url ? datasheet_url : "#"} target={datasheet_url ? "_blank" : ""}>
          {loading ? (
              <Skeleton width={80} height={80} />
            ) : datasheet_qr_code ? (
              <img
                src={url + datasheet_qr_code}
                alt="QR Code"
                style={{ height: 80, width: 80 }}
              />
            ) : null}
            <div>
              <div className="product-type">
                {loading ? <Skeleton width={100} /> : item_group}
              </div>
              <div className="product-name">
                {loading ? <Skeleton width={150} /> : web_item_name}
              </div>
            </div>
          </a>

          {
            loading ? (
              <Skeleton count={3} />
            ) : (
              short_description && (
                <div className="product-des">
                  {short_description}
                </div>
              )
            )
          }
         

          <div className="flex">
            {loading ? (
              <Skeleton width={120} height={40} />
            ) : (
              <button className="hero-btn" onClick={() => setShowModal(true)}>Get Quotation</button>
            )}
            
            {/* Only show video play button if demo_video exists */}
            {embedVideoUrl && (
              <div className="video-play" onClick={handleShowVideo}>
                {loading ? (
                  <Skeleton circle={true} height={40} width={40} />
                ) : (
                  <img src={PlayVideo} alt="Play" className="play-video-icon" />
                )}
                <span style={{ marginLeft: "8px" }}>
                  {loading ? <Skeleton width={80} /> : "How to use?"}
                </span>
              </div>
            )}
            {brand_image && (
            <div className="brand-container">
              <div className="seperator"></div>
              <div className="brand-section">
              
                <>
                  <span className="by">BY</span>
                  {loading ? (
                    <Skeleton className="logo-skeleton-loading" />
                  ) : (
                    <img src={`${url}/${brand_image}`} className="brand-img" alt="Brand" />
                  )}
                </>
              

               
              </div>
            </div>
            )}
          </div>
        </Col>

        <Col xs={12} sm={12} md={12} lg={6} className="gallery-column">
          {loading ? (
            <Skeleton height={300} />
          ) : (
            <>
              {images.length > 0 ? (
                <Gallery images={images} />
              ) : (
                <div className="single-image-container">
                  {
                    website_image && (
                      <img
                        src={`${url}/${website_image}`}
                        alt="Product Image"
                        className="main-image"
                      />
                    )
                  }
                  
                </div>
              )}
            </>
          )}
        </Col>
      </Row>

      {/* Video Modal */}
      <Modal show={showVideoModal} onHide={handleCloseVideo} centered dialogClassName="use-modal-width">
        <Modal.Header closeButton>
          <Modal.Title>Product Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {embedVideoUrl ? (
            <iframe
              width="900"
              height="500"
              src={embedVideoUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <p>Demo video not available</p>
          )}
        </Modal.Body>
      </Modal>

      <ComingSoon show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default Header;
